import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const ReturnsPolicy = () => {
  return (
    <div className="pb-16 bg-brand-bone min-h-screen" data-testid="returns-page">
      {/* Hero */}
      <section className="bg-brand-black/[0.03] py-12 md:py-20 border-b border-brand-cobalt/10">
        <div className="max-w-4xl mx-auto px-4">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-sm text-brand-cobalt hover:text-brand-cobalt/80 mb-6"
          >
            <ArrowLeft size={16} />
            Volver al inicio
          </Link>
          <h1 className="font-display text-3xl md:text-5xl tracking-tight mb-4 text-brand-black">
            Cambios y Reembolsos
          </h1>
          <p className="text-brand-black/60 text-lg">
            Política de devoluciones de Alphatica
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 md:py-16">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-lg max-w-none">
            <p className="text-brand-black/80 leading-relaxed mb-8">
              Debido a la naturaleza de los productos comercializados por Alphatica, que consisten en 
              fragancias de uso personal, las devoluciones están sujetas a ciertas restricciones.
            </p>

            <div className="brand-card hybrid-glow p-6 rounded-lg mb-8">
              <h2 className="font-display text-xl md:text-2xl mb-4 text-brand-cobalt">Productos dañados o defectuosos</h2>
              <p className="text-brand-black/80 mb-4">
                Si el cliente recibe un producto dañado, roto o defectuoso, deberá reportarlo dentro de las 
                <strong className="text-brand-black"> 48 horas posteriores</strong> a la recepción del pedido.
              </p>
              <p className="text-brand-black/80 mb-4">Para procesar la solicitud, se podrá solicitar:</p>
              <ul className="space-y-2 text-brand-black/80 mb-4">
                <li className="flex items-start gap-2">
                  <span className="text-brand-petroleum">•</span>
                  Número de pedido
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-brand-petroleum">•</span>
                  Fotografías del producto
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-brand-petroleum">•</span>
                  Descripción del problema
                </li>
              </ul>
              <p className="text-brand-black/80">Una vez evaluado el caso, Alphatica podrá ofrecer:</p>
              <ul className="space-y-2 text-brand-black/80 mt-2">
                <li className="flex items-start gap-2">
                  <span className="text-brand-petroleum">•</span>
                  Reposición del producto
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-brand-petroleum">•</span>
                  Reembolso total o parcial
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-brand-petroleum">•</span>
                  Crédito para futuras compras
                </li>
              </ul>
            </div>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-black">Productos abiertos</h2>
            <p className="text-brand-black/80 mb-8">
              Por razones de higiene y seguridad, <strong className="text-brand-black">no se aceptan devoluciones ni cambios</strong> de 
              perfumes que hayan sido abiertos o utilizados, salvo en caso de defectos de fabricación.
            </p>

            <h2 className="font-display text-xl md:text-2xl mt-10 mb-4 text-brand-black">Cancelaciones</h2>
            <p className="text-brand-black/80 mb-4">
              Los pedidos podrán cancelarse únicamente si aún no han sido enviados.
            </p>
            <p className="text-brand-black/80">
              Una vez que el pedido ha sido entregado a la empresa de mensajería, la cancelación ya no será posible.
            </p>

            {/* Contact CTA */}
            <div className="mt-12 brand-card hybrid-glow p-6 rounded-lg text-center border border-brand-cobalt/30">
              <h3 className="font-display text-xl mb-2 text-brand-black">¿Necesitas hacer una devolución?</h3>
              <p className="text-brand-black/60 mb-4">Contáctanos dentro de las primeras 48 horas</p>
              <Link 
                to="/contact" 
                className="inline-flex items-center gap-2 brand-btn rounded"
              >
                Contactar Soporte
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ReturnsPolicy;
